//algorithm: "ГОСТ Р 34.10-2012 256 бит"
// from: "28.10.2021 08:14:06"
// issuer: "CN=CRYPTO-PRO Test Center 2"
// location: "да"
// privateKeyLink: "REGISTRY\\\\fa52328d7-be57-6019-763c-7f643ff546d"
// provname: "Crypto-Pro GOST R 34.10-2012 Cryptographic Service Provider"
// status: "Действителен"
// subject: {
// CN = ТПП РОССИИ, ТПП РФ
// SN = Судзиловский
// G = Борис Никитич
// C = RU
// S = 77 г. Москва
// L = Москва
// STREET = УЛ ИЛЬИНКА, ДОМ 6/1, 1
// O = ТПП РОССИИ, ТПП РФ
// OU = Департамент цифрового развития
// T = Руководитель направления
// ОГРН = 1027746000853
// СНИЛС = 05283170243
// ИНН = 007710026920
// E = sbn@tpprf.ru
// }
// till: "28.01.2022 08:24:06"
const PROPS_CERT = [
	'algorithm',
	'from',
	'till',
	'issuer',
	'location',
	'privateKeyLink',
	'provname',
	'status',
	'subject',
	'serial',
];

class cryptoproCert {
	constructor(cert) {
		this.cert = {};
		PROPS_CERT.forEach((prop) => {
			let value =
				prop === 'subject' && typeof cert[prop] === 'string'
					? this.parseSubject(cert[prop])
					: cert[prop];
			if (!value && prop === 'subject') {
				value = {};
			}
			this.cert[prop] = value || '';
		});
	}

	getData() {
		return this.cert;
	}

	ucFirst(str) {
		if (!str) return str;
		str = str.toLowerCase();
		return str[0].toUpperCase() + str.slice(1);
	}

	dateFrom() {
		return this.cert['from'];
	}

	dateTo() {
		return this.cert['till'];
	}

	issuer() {
		return this.cert['issuer'];
	}

	privateKey() {
		return this.cert['privateKeyLink'];
	}

	provname() {
		return this.cert['provname'];
	}

	subject() {
		return this.cert['subject'];
	}

	owner(part) {
		const parts = {
			'surname': 2, 
			'lastname': 0, 
			'name': 1,
			'secondname': 2,
		}
		const full = [this.subject()['SN'], this.subject()['G']].join(' ').trim();
		let arName = full.split(' ');
		arName = arName.map(this.ucFirst);

		if(part) {
			part = part.replace('-', '').toLowerCase();
			const index = parts[part];
			const partValue = arName[index];
			if(partValue) {
				return partValue;
			}
		}

		return arName.join(' ');
	}

	orgName() {
		return this.subject()['O'];
	}

	subdivisionName() {
		return this.subject()['OU'];
	}

	inns() {
		return Object.entries(this.subject()).filter(([key, value]) => {
			return (key.includes('INN') || key.includes('ИНН')) && (value.length === 10 || value.length === 12);
		})
			.map(([key, value]) => value)
	}

	inn() {
		// let inn = this.subject()['ИНН'] || this.subject()['INN'] || '';
		// if (inn.length === 12 && inn.substr(0, 2) == '00') {
		// 	inn = inn.substr(2, 12);
		// }
		// return inn;
		return this.innOrg();
	}

	innIndividual() {
		const inns = this.inns();

		for(let i = 0; i < inns.length; i += 1) {
			const inn = inns[i];
			if (inn.length === 12 && inn.substr(0, 2) != '00') {
				return inn;
			}
		}
	}

	innOrg() {
		const inns = this.inns();
		for(let i = 0; i < inns.length; i += 1) {
			const inn = inns[i];

			if(inn.length === 10) {
				return inn;
			}
	
			if(inn.substr(0, 2) == '00') {
				return inn.substr(2, 12);
			}
		}

		return (
			this.subject()['OID.1.2.643.100.4'] || this.subject()['OID 1.2.643.100.4']
		);
	}

	// innIndividual() {
	// 	const inn = this.inn();
	// 	return inn.length === 12 ? inn : null;
	// }

	ogrn() {
		return (
			this.subject()['ОГРН'] ||
			this.subject()['OGRN'] ||
			this.subject()['OGRNIP'] ||
			this.subject()['ОГРНИП'] ||
			this.subject()['OID 1.2.643.100.5']
		);
	}

	snils() {
		return this.subject()['СНИЛС'] || this.subject()['SNILS'];
	}

	post() {
		return this.ucFirst(this.subject()['T']);
	}

	kpp() {
		return this.subject()['КПП'] || this.subject()['KPP'];
	}

	email() {
		return this.subject()['E'];
	}

	isBelongedOrg() {
		return !!this.ogrn();
	}

	parseSubject(string) {
		// const namePattern = 'А-Яа-яA-Za-z0-9.';
		// const regex = /,?\s*([А-Яа-яA-Za-z0-9]+)=/;
		// let newValue = value.split(regex).filter(Boolean);
		// let result = [];
		// newValue.forEach((el, index) => {
		// 	index = index + 1;
		// 	if (index % 2 == 0) {
		// 		result[index - 2].push(el);
		// 	} else {
		// 		result[index - 1] = [el];
		// 	}
		// });
		// result = result.filter(Boolean);
		// result = result.reduce((acc, el) => {
		// 	acc[el[0]] = el[1];
		// 	return acc;
		// }, {});
		// return result;
		return string.split(/,\s+/g).reduce(function (acc, el) {
			var res = el.split('=');
			acc[res[0]] = res[1];
			return acc;
		}, {});
	}
}

export default cryptoproCert;
